import React from "react";
import LightGallery from "lightgallery/react";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";

import lgZoom from "lightgallery/plugins/zoom";
import lgThumbnail from "lightgallery/plugins/thumbnail";

import noImagen from "images/no-image.jpg";

const ImageLightbox = ({
  src,
  alt = "",
  width = 60,
  className = "rounded",
  showNoImage = true,
}) => {
  if (!src) {
    if (!showNoImage) return null;
    return <img src={noImagen} alt={alt} className={className} width={width} />;
  }

  return (
    <LightGallery
      speed={500}
      plugins={[lgZoom, lgThumbnail]}
      download={false}
      elementClassNames="d-inline-block"
    >
      <a href={src} style={{ display: "inline-block", cursor: "pointer" }}>
        <img
          src={src}
          alt={alt}
          className={className}
          style={{
            width: `${width}px`,
            height: "auto",
            maxWidth: `${width}px`,
          }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noImagen;
          }}
        />
      </a>
    </LightGallery>
  );
};

export default ImageLightbox;
